'use strict'

function createEmblemUrl(emblemHost, queryParams) {
    const search = Object.entries(queryParams).reduce((acc, [key, value]) => {
        if (value) acc.append(key, value)
        return acc
    }, new URLSearchParams())
    if (queryParams.reviewRedirectUrl) {
        search.set('onSuccessUrl', queryParams.reviewRedirectUrl)
    }
    return `${emblemHost}/redirect?${search.toString()}`
}
function validateProps(props) {
    const errors = []
    if (!props.url || typeof props.url !== 'string') {
        errors.push('Missing required prop: url')
    }
    if (!props.projectKey || typeof props.projectKey !== 'string') {
        errors.push('Missing required prop: projectKey')
    }
    if (!props.state || typeof props.state !== 'string') {
        errors.push('Missing required prop: state')
    }
    if (props.postbackUrl && typeof props.postbackUrl !== 'string') {
        errors.push('postbackUrl must be a string')
    }
    if (props.postbackHeaders && typeof props.postbackHeaders !== 'string') {
        errors.push('postbackHeaders must be a string')
    }
    if (props.postbackOverride && typeof props.postbackOverride !== 'boolean') {
        errors.push('postbackOverride must be a boolean')
    }
    return {
        isValid: errors.length === 0,
        errors,
    }
}
class EmblemSDK {
    constructor(config) {
        var _a
        this._onClickCallback = null
        this._closeWindowCallback = null
        this._childWindow = null
        const validation = validateProps(config)
        if (!validation.isValid) {
            throw new Error(`Invalid configuration: ${validation.errors.join(', ')}`)
        }
        this.config = config
        this._mixpanelEnabled = (_a = config.enableMixpanel) !== null && _a !== void 0 ? _a : true
    }
    createRedirectUrl() {
        const {
            url,
            projectKey,
            state,
            reviewRedirectUrl,
            postbackUrl,
            postbackHeaders,
            postbackOverride,
        } = this.config
        const params = {
            projectKey,
            emblemState: state,
            reviewRedirectUrl,
            postbackUrl,
            postbackHeaders,
            postbackOverride: postbackOverride ? 'true' : undefined,
        }
        return createEmblemUrl(url, params)
    }
    onVerificationClick(callback) {
        if (typeof callback === 'function') {
            this._onClickCallback = callback
        }
        return this
    }
    onWindowClose(callback) {
        if (typeof callback === 'function') {
            this._closeWindowCallback = callback
        }
        return this
    }
    verify() {
        const { state, projectKey } = this.config
        // Track click if mixpanel is available and enabled
        if (this._mixpanelEnabled && window.mixpanel) {
            window.mixpanel.track('Emblem Button Click', { emblemState: state, projectKey })
        }
        if (this._onClickCallback) {
            this._onClickCallback()
        }
        const emblemRedirectRoute = this.createRedirectUrl()
        window.location.href = emblemRedirectRoute
        // this._childWindow = window.open(emblemRedirectRoute, '_blank');
        // if (this._closeWindowCallback && this._childWindow) {
        //   const checkWindow = setInterval(() => {
        //     if (this._childWindow?.closed) {
        //       clearInterval(checkWindow);
        //       this._closeWindowCallback?.();
        //     }
        //   }, 1000);
        // }
    }
}

// module.exports = EmblemSDK;
export default EmblemSDK
//# sourceMappingURL=sdk.js.map
